<template>
  <div class="home-wrap">
    <div class="topbox">
      <div class="leftbox">
        {{ name }}
      </div>
      <div class="rightbox">
        <!-- <el-input :placeholder="$t('home.ehcartinput')" v-model="input2">
          <i slot="suffix" class="iconfont icon-sousuo" @click="getdata"></i>
        </el-input> -->
        <div class="box1" @click="toManageSys">
          <span
            class="iconfont icon-fanhui"
            style="font-size:12px;margin-right:5px"
          ></span>
          {{ $t("home.Returnmanagement") }}
        </div>

        <el-dropdown class="avatar-container right-menu-item hover-effect">
          <div class="avatar-wrapper">
            <div class="box iconfont icon-qiehuanyuyin"></div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <span>English</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span>粤语</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span>普通话</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown class="avatar-container right-menu-item hover-effect">
          <div class="avatar-wrapper">
            <div class="box  iconfont icon-qiehuanyuyan"></div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in menuList" :key="index">
              <span @click="handlemenu(item)">{{ item.name }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-popover placement="top-start" width="164px" trigger="hover">
          <div class="logoutcontent">
            <div class="bottom">
              <div class="iconfont icon-dengchu"></div>
              <div class="logout" style="color:#FF258E;font-size: 14px;">
                {{ $t("mySet.logOut") }}
              </div>
            </div>
          </div>
          <div
            class="iconfont  icon-guanliyuan3 s-icon"
            style="background-color: none;"
            slot="reference"
          ></div>
        </el-popover> -->
      </div>
    </div>

    <div class="bottombox">
      <div class="msgbox">
        <div class="msgcontent">
          <div class="img"></div>
          <div class="str">IN BED</div>
        </div>
        <div class="msgcontent">
          <div class="img" style="background: #FF654B;"></div>
          <div class="str">OFF BED</div>
        </div>
        <div class="msgcontent">
          <img src="../../assets/img/home/smile.png" class="img1" alt="" />
          <div class="str">HEALTHY</div>
        </div>
        <div class="msgcontent">
          <img src="../../assets/img/home/busmile.png" class="img1" alt="" />
          <div class="str">UNHEALTHY</div>
        </div>
        <div class="msgcontent">
          <div
            class="img"
            style="background: #F8CD40; border-radius: 21px;"
          ></div>
          <div class="str">MOVEMENT</div>
        </div>
        <div class="msgcontent">
          <div
            class="img"
            style="background: #FF654B;
box-shadow: 0px 0px 11px 0px #EE3936;"
          ></div>
          <div class="str">ALARM</div>
        </div>
      </div>
      <!-- <el-scrollbar style="height: 100%; width: 100%">
        <div
          class="content"
          v-for="item in realtimedata"
          :key="item.areaid"
          :class="item == 7 ? 'warning' : ''"
        >
          <div class="title">{{ item.areaName }}</div>
        
          <div class="img" :style="{background:item.groundState?'#B4EFC8':'#E9ECF6'}">
            <div class="men" v-if="!item.doorState"></div>
            <div class="men1" v-else></div>
            <div
              class="yushi"
              :style="{ background: item.yuShiState ? '#87DBA5' : '#E9ECF6' }"
            ></div>

            <div
              class="chuang"
              v-if="item.bedState == 2"
              style="background:#88DAA5"
            ></div>
            <div
              class="chuang"
              v-else-if="item.bedState == 1"
              style="background:#F1CA23"
            ></div>
            <div class="chuang" v-else style="background:#F5691E"></div>
          </div>
          <div class="msg">
            <div class="heart">
              <span class="iconfont  icon-aixin"></span>
              <span class="text">
                {{ item.heart == null ? "--" : item.heart }} bpm</span
              >
            </div>
            <div class="tidong">
              <span class="iconfont  icon-tidong"></span>
              <span class="text" v-if="item.moveBody && item.bedState == 2">{{
                $t("home.move")
              }}</span>
              <span
                class="text"
                v-else-if="!item.moveBody && item.bedState == 2"
                >{{ $t("home.notMove") }}</span
              >
              <span class="text" v-else="!item.moveBody && item.bedState == 2"
                >--</span
              >
            </div>
            <div class="wendu">
              <span class="iconfont  icon-wendu"></span>
              <span class="text">
                {{ item.wenDu == null ? "--" : item.wenDu }} °C</span
              >
            </div>
            <div class="huxi">
              <span class="iconfont  icon-fei1"></span>
              <span class="text">
                {{ item.breath == null ? "--" : item.breath }} rpm</span
              >
            </div>
            <div class="zaichuang">
              <span class="iconfont  icon-zaichuang"></span>
              <span
                class="text"
                v-if="item.bedState == 2"
                style="color:#36D263"
                >{{ $t("home.InBed") }}</span
              >
              <span class="text" v-else-if="item.bedState == 1" style="color:#F3C921">{{
                $t("home.leavebed")
              }}</span>
              <span class="text" style="color:#F5691E" v-else>{{
                $t("home.offbed")
              }}</span>
            </div>
            <div class="shidu">
              <span class="iconfont  icon-shidu"></span>
              <span class="text">
                {{ item.shiDu == null ? "--" : item.shiDu }} %</span
              >
            </div>
          </div>
        </div>
    
      </el-scrollbar> -->

      <div
        class="content1"
        :class="!item.alarm ? '' : 'warn'"
        :style="{ width: item.quyuKuandu == '18%' ? '18.85%' : '38.5%' }"
        v-for="(item, index) in realtimedata"
        :key="index"
      >
        <div class="titlebox">
          <div class="title">{{ item.areaName }}</div>
          <div class="wenshidu">
            <div class="wendu">
              <span class="iconfont icon-wendu" style="color:#60B630; "></span
              >{{ item.wendu == null ? "--" : item.wendu }}℃
            </div>
            <div class="shidu">
              <span class="iconfont icon-shidu" style="color:#2FC8C6; "></span
              >{{ item.shidu == null ? "--" : item.shidu }}%
            </div>
          </div>
        </div>
        <div class="neirong">
          <div
            v-for="(items, indexs) in item.roomItems"
            :key="indexs"
            :class="
              items.styleJson == 2 ? 'men' : items.type == 3 ? 'chuang' : 'men1'
            "
            :style="items.styleJson == '' ? {} : JSON.parse(items.styleJson)"
            v-if="items.type != 1"
          >
            <div
              v-if="items.type == 2"
              style="width: 100%;height:100%"
              :class="getclass(items.data, 'pir_state')"
            ></div>
            <div
              v-if="items.type == 3"
              @mouseover="chuanghover($event, items)"
              @mouseleave="chuanghoverleave($event, items)"
              :class="!items.alarm ? '' : 'red'"
              style="border-radius: 5px 5px 0 0;"
            >
              <div class="num">{{ items.name }}</div>
              <div
                class="chuangrenti"
                :class="getclass(items.data, 'device_onbed')"
              >
                <img
                  src="../../assets/img/home/busmile.gif"
                  class="smile"
                  alt=""
                  v-if="
                    items.alarm && getvalue(items.data, 'device_onbed') == 1
                  "
                />
                <img
                  src="../../assets/img/home/smile.png"
                  class="smile"
                  alt=""
                  v-else-if="
                    !items.alarm && getvalue(items.data, 'device_onbed') == 1
                  "
                />
                <img
                  src="../../assets/img/home/tidong.gif"
                  class="tidong"
                  alt=""
                  v-show="getvalue(items.data, 'device_movebody') == 1"
                />
                <!-- <div
                  class="tidong"
                  v-show="getvalue(items.data, 'device_movebody') == 1"
                ></div> -->
              </div>
              <div
                class="msgbox"
                v-show="items.hover"
                :style="{
                  right: isleft ? '90px' : '-254px',

                  background: 'url(' + imgsrc + ') no-repeat',
                }"
              >
                <div
                  class="itemname"
                  :style="{
                    left: isleft ? '40px' : '55px',
                  }"
                >
                  {{ items.name }}
                </div>
                <div
                  class="title"
                  :style="{
                    left: isleft ? '40px' : '55px',
                  }"
                >
                  {{ items.bindFirstName == null ? "--" : items.bindFirstName }}

                  {{ items.bindLastName == null ? "--" : items.bindLastName }}
                </div>
                <div
                  class="shuju"
                  :style="{
                    padding: isleft ? '0 40px 0 20px' : '0 20px 0 40px',
                  }"
                >
                  <div class="bpm">
                    <img
                      src="../../assets/img/home/xin.png"
                      style="width: 18px;
                      height: 17px;"
                      class="img"
                      alt=""
                    />
                    {{ getvalue(items.data, "device_heart") }}
                    <span style="font-size: 7px;">bpm</span>
                  </div>
                  <div class="rpm">
                    <img
                      src="../../assets/img/home/fei.png"
                      class="img"
                      style="width: 18px;
                      height: 17px;"
                      alt=""
                    />
                    {{ getvalue(items.data, "device_breath") }}
                    <span style="font-size: 7px;">rpm</span>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="men12"
              :class="getclass(items.data, 'doorcontact_state')"
              v-if="items.type == 0"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseBackManageUrl } from "@/lib/global";
import { baseSignalrUrl } from "@/lib/global";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { CurentTime } from "@/lib/tools.js";
import { darkmagenta } from "color-name";
import img1 from "@/assets/img/home/left.png";
import img2 from "@/assets/img/home/right.png";
import Vue from "vue";
const signalR = require("@microsoft/signalr");
export default {
  name: "home",
  data() {
    return {
      connection: "",
      animate: false,
      checkList: [],
      realtimedata: [],
      warnlist: [],
      input2: "",
      name: "",
      pageWidth: 0,
      isleft: false,
      ismsg: 0,
      img1: img1,
      img2: img2,
      class1: {
        borderRight: "1px solid #fff",

        borderBottom: "1px solid #fff",
      },
      box1data: [
        { time: "2020/05/16", text: "A110 - 離床超時1" },
        { time: "2020/05/17", text: "A110 - 離床超時2" },
        { time: "2020/05/18", text: "A110 - 離床超時3" },
      ],
      menuList: [
        {
          name: "English",
          val: "en",
        },
        {
          name: "简体中文",
          val: "cn",
        },
        {
          name: "繁体中文",
          val: "tw",
        },
        // {
        // 	name: '日本語',
        // 	val: 'ja'
        // },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getDeviceBaseList",
      "getDeviceSimpleData",
      "getDeviceWarnList",
      "getDeviceWarnStatic",
    ]),
    imgsrc() {
      if (this.isleft) {
        return this.img2;
      } else {
        return this.img1;
      }
    },
  },
  components: {},
  created() {
    this.$api.home.getrealtimedata().then((res) => {
      this.realtimedata = res;
    });
  },
  mounted() {
    this.init();
    let url = window.location.href.split("?");
    let a = url[1].split("&")[1].split("=")[1];
    this.name = decodeURIComponent(a);
    this.getWindowWidth();
    window.addEventListener("resize", this.getWindowWidth);
  },
  methods: {
    ...mapActions([
      "initConnect",
      "setDeviceBaseList",
      "setDeviceWarnList",
      "setDeviceWarnStatic",
    ]),
    getvalue(datass, str) {
      let c = null;

      c = datass.find((ress) => ress.code == str);

      if (c != undefined) {
        return c.value;
      } else {
        return "--";
      }
    },
    getclass(datass, str) {
      let c = datass.find((ress) => ress.code == str);

      let classstr = "";
      if (c != undefined) {
        switch (str) {
          case "device_onbed":
            if (c.value * 1 == 1) {
              return "green";
            } else {
              return "red";
            }
            break;
          case "pir_state":
            if (c.value * 1 == 1) {
              return "green";
            } else {
              return "red";
            }
            break;
          case "doorcontact_state":
            if (c.value * 1 == 1) {
              return "men22";
            } else {
              return "";
            }
            break;
          default:
            return "green";
            break;
        }
      } else {
        if (str == "pir_state") {
          return "red";
        } else if (str == "device_onbed") {
          return "red";
        } else {
          return "";
        }
      }
    },
    getWindowWidth() {
      this.pageWidth =
        window.innerWidth || document.documentElement.clientWidth;
    },
    init() {
      let that = this;
      let url = window.location.href.split("?");
      let a = url[1].split("&")[0].split("=")[1];
      console.log(baseSignalrUrl);
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(baseSignalrUrl, {
          accessTokenFactory: () => {
            return a;
          },
        })
        .configureLogging(signalR.LogLevel.Error)
        .withAutomaticReconnect()
        .build();
      this.connection.on("areaBaseData@1", (data) => {
        // data = JSON.parse(data);

        let a = that.realtimedata.find((res) => res.areaId == data.roomId);
        let b = null;
        if (a != undefined) {
          b = a.roomItems.find(
            (res) => res.bindDeviceCode == data.data[0].deviceCode
          );
        }
        // let b = a.roomItems.findIndex((res) => res.bindDeviceCode == data.data[0].deviceCode);

        if (b != null) {
          data.data.forEach((res) => {
            try {
              let c = b.data.find((ress) => ress.code == res.code);
              if (c == undefined) {
                if (res.value * 1 == 65436 || res.value * 1 == 156) {
                  res.value = "--";
                }

                b.data.push(res);
              } else {
                if (res.value * 1 == 65436 || res.value * 1 == 156) {
                  res.value = "--";
                }

                c.value = res.value;
                c.lastMsgStr = res.lastMsgStr;
              }
              if (res.code == "temp_current") {
                a.wendu = res.value;
              }
              if (res.code == "offline") {
                a.alarm = false;
                b.alarm = false;
                b.data.find((ress) => ress.code == "device_onbed").value = 0;
                b.data.find((ress) => ress.code == "device_movebody").value = 0;
                b.data.find((ress) => ress.code == "device_onbed").value = 0;
              }
              if (res.code == "humidity_value") {
                a.shidu = res.value;
              }
            } catch (error) {
              console.log(data);
            }
          });

          // that.$nextTick((res) => {
          //   Vue.set(that.realtimedata, a, data);
          // });
        } else {
          data.data.forEach((res) => {
            try {
              if (res.code == "temp_current") {
                a.wendu = res.value;
              }

              if (res.code == "humidity_value") {
                a.shidu = res.value;
              }
            } catch (error) {
              console.log(data);
            }
            if (res.code == "offline") {
              a.alarm = false;
              b.alarm = false;
              b.data.find((ress) => ress.code == "device_onbed").value = 0;
              b.data.find((ress) => ress.code == "device_movebody").value = 0;
              b.data.find((ress) => ress.code == "device_onbed").value = 0;
            }
          });
        }
      });
      this.connection.on("areaWarnData@1", (data) => {
        try {
          let a = that.realtimedata.find((res) => res.areaId == data.roomId);
          let b = null;

          if (!data.data.over) {
            console.log(data.data.over);
            // that.$notify({
            //   title: "标题名称",
            //   message: h(
            //     "i",
            //     { style: "color: teal" },
            //     "这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案"
            //   ),
            // });
            that.$notify.error({
              title: "",
              message:
                data.roomName +
                "-" +
                data.data.roomItemName +
                "-" +
                that.$t("warn." + data.data.warnType),
              position: "bottom-right",
              duration: 30000,
            });
            a.alarm = true;
            b = a.roomItems.find(
              (res) => res.bindDeviceCode == data.data.deviceCode
            );
            b.alarm = true;
          } else {
            if (a != undefined) {
              a.alarm = false;
              b = a.roomItems.find(
                (res) => res.bindDeviceCode == data.data.deviceCode
              );
              b.alarm = false;
            }
          }
        } catch (error) {}
      });

      this.connection.start();
      this.connection.onclose((error) => {
        this.start();
      });
    },
    async start() {
      try {
        await that.connection.start();
        console.log("signaR连接成功");
      } catch (err) {
        console.log("err", err);
        setTimeout(this.start(), 5000);
      }
    },
    chuanghover(e, a) {
      if (1780 - e.clientX * 1 < 300) {
        this.isleft = true;
      } else {
        this.isleft = false;
      }
      a.hover = true;
    },
    chuanghoverleave(e, a) {
      a.hover = false;
    },
    getdata(data) {
      debugger;
      let a = [
        {
          type: "chuang",
          shuju: {},
          class: {
            marginRight: "30px",
            marginLeft: "30px",
          },
        },
      ];
      this.$api.home.getrealtimedata(this.input2).then((res) => {
        this.realtimedata = res;
        console.log(res);
      });
    },
    handleLange(item) {
      debugger;
      this.Language = item.val;

      localStorage.setItem("Language", JSON.stringify(item.val));
    },
    handlemenu(item) {
      debugger;
      this.$nextTick(function() {
        this.$i18n.locale = item.val;

        let LanguageObj = {
          title: item.name,
          Language: item.val,
        };
        localStorage.setItem("LanguageObj", JSON.stringify(LanguageObj));
      });
    },
    scroll() {
      this.box1data.unshift({
        time: Math.random(10),
        text: "A110 - 離床超時0",
      });
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true

      let a = this.box1data.length;

      this.box1data.splice(this.box1data.length - 1, 1);
      setTimeout(() => {
        this.animate = false;
        // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      }, 500);
    },
    toManageSys() {
      let url = window.location.href.split("?");

      let curLang = url[1].split("&")[2].split("=")[1];
      if (localStorage.getItem("LanguageObj")) {
        let LanguageObj = JSON.parse(localStorage.getItem("LanguageObj"));
        curLang = LanguageObj.Language;
      }
      window.location.href = baseBackManageUrl + "?curLang=" + curLang; //跳转到大屏
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.icon-dengchu {
  position: absolute;
  width: 2rem;
  height: 2rem;
  background: rgba(79, 134, 255, 0.08);
  border-radius: 0.625rem;
  line-height: 2rem;
  text-align: center;
  color: #ff258e;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
}
.logout {
  margin-left: 1rem;
  line-height: 2rem;
  text-align: center;
  font-size: 12px;
  color: #ff258e;
}
@import "home.scss";
</style>
